export default "__VITE_ASSET__YkL9FUKZ__"